import { USER_INVITATIONS_QUERY } from 'modules/App/queries/queries';

export const invalidateQueries = [USER_INVITATIONS_QUERY];
